import { render } from "./index1.vue?vue&type=template&id=1e96e807"
import script from "./index1.vue?vue&type=script&lang=js"
export * from "./index1.vue?vue&type=script&lang=js"

import "./index1.vue?vue&type=style&index=0&id=1e96e807&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__